import { FC } from 'react'

import { Spacer } from '@syconium/little-miss-figgy'

import { trackEvent } from '../../../../../../lib/analytics'
import { formatPrettyTitlePG } from '../../../../../../lib/utils/unorganized'
import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { useIsPhysicalGiftCard } from '../../hooks/useIsGiftCard'
import { Description } from '../../ProductHighlights/styles'

import { GiftCardCtas } from './Ctas'
import { DigitalText } from './DigitalText'
import { DropdownSection } from './DropdownSection'
import { GiftLinks } from './GiftLinks'
import { PhysicalText } from './PhysicalText'

export const GiftCardDetails: FC = () => {
  const { sizes, productGroup, selectedSize } = ProductDetailsContainer.useContainer()

  const { description: productGroupDescription, handle: productGroupHandle } = productGroup

  const title = formatPrettyTitlePG(productGroup)

  const isPhysicalGiftCard = useIsPhysicalGiftCard({
    productGroupHandle,
  })

  return (
    <>
      <Spacer height={20} />

      <DropdownSection sizes={sizes} isInvalid={false} selection={selectedSize?.shorthand} />

      <GiftCardCtas />

      <Spacer height={16} />

      {productGroupDescription ? (
        <Description
          {...trackEvent({
            category: 'product details',
            action: 'snapshot',
            label: 'description',
            value: title,
          })}
        >
          {productGroupDescription}
        </Description>
      ) : null}

      <Spacer height={16} />

      {isPhysicalGiftCard ? <PhysicalText /> : <DigitalText />}

      <GiftLinks />
    </>
  )
}
